const dataFormDesign = () =>
    import(/* webpackChunkName: "design-main" */ '@/views/back-stage/form-design/design-main.vue');
const formDesign = () =>
    import(/* webpackChunkName: "form-design" */ '@/views/back-stage/form-design/form-design.vue');
const flowDesign = () =>
    import(/* webpackChunkName: "flow-design" */ '@/views/back-stage/form-design/flow-design.vue');
const advancedDesign = () =>
    import(/* webpackChunkName: "advanced-setting" */ '@/views/back-stage/form-design/advanced-setting.vue');
const listAdvancedDesign = () =>
    import(/* webpackChunkName: "list-advanced-design" */ '@/views/back-stage/form-design/list-advanced-design.vue');

const sheetLog = () =>
    import(/* webpackChunkName: "list-advanced-design" */ '@/views/back-stage/form-design/sheet-log.vue');

const websiteDesign = () =>
    import(/* webpackChunkName: "website-design" */ '@/views/back-stage/application-function-design/website.vue');

const treeListDesign = () =>
    import(/* webpackChunkName: "tree-list-design" */ '@/views/back-stage/application-function-design/tree-list.vue');

const dataFormDesignRoutes = [
    {
        path: 'form',
        name: 'form-design',
        component: formDesign,
    },
    {
        path: 'flow',
        name: 'flow-design',
        component: flowDesign,
    },
    {
        path: 'advancedlist',
        name: 'list-advanced-design',
        component: listAdvancedDesign,
    },
    {
        path: 'advanced',
        name: 'advanced-design',
        component: advancedDesign,
    },
    {
        path: 'sheetlog',
        name: 'sheet-log',
        component: sheetLog,
    },
    {
        path: '*',
        redirect: 'form',
    },
];

const DataFormDesignRoute = {
    path: '/design',
    name: 'design',
    component: dataFormDesign,
    children: dataFormDesignRoutes,
};

const FunctionDesignRoutes = [
    {
        path: '/websitedesign',
        name: 'websitedesign',
        component: websiteDesign,
    },
    {
        path: '/treelistdesign',
        name: 'treelistdesign',
        component: treeListDesign,
    },
];

export { DataFormDesignRoute, FunctionDesignRoutes };
